var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": _vm.handleMobileNavigate
    }
  }, [_c('div', {
    class: _vm.$style.main
  }, [_c('div', {
    class: [_vm.$style.navigate, _vm.$style.mobile]
  }, [_c('arrow-left-icon', {
    directives: [{
      name: "fill",
      rawName: "v-fill:white",
      arg: "white"
    }]
  })], 1), _c('div', {
    class: [_vm.$style.navigate, _vm.$style.desktop]
  }, [_c('navigate-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "navigate": _vm.handleNavigate
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('h1', {
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.displayTitle))]), _vm.displayDescription ? _c('p', {
    class: _vm.$style.description,
    domProps: {
      "innerHTML": _vm._s(_vm.displayDescription)
    }
  }) : _vm._e()])]), _vm.$slots.hasOwnProperty('toolbar') ? _c('div', {
    class: _vm.$style.toolbar,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("toolbar")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }